import React from 'react';

export const EstimatedQuoteText = ({productVersionIdRef}) =>{
  let EstQuoteText;
  switch(productVersionIdRef){
    case 'iic-CA-Homeowners-v01-00-00':
      EstQuoteText = (
          <div id="estimated-quote-text">
            <p>This estimate is based on the information you’ve entered so far for commonly requested coverages, deductibles and limits. If you are happy with this estimate and the details below, click Apply.
                Otherwise, you can adjust the coverages to see an updated premium estimate.
            </p>
          </div>
      );
      break;
    case 'iic-CA-PersonalAuto-v01-00-00':
      EstQuoteText = (
          <div id="estimated-quote-text">
            <p>This estimate is based on the information you’ve entered so far for commonly requested coverages, deductibles and limits. If you are happy with this estimate and the details below, click Apply.
                Otherwise, you can adjust the coverages to see an updated premium estimate.
            </p>
          </div>
      );
      break;
    default:
      EstQuoteText = (
          <div id="estimated-quote-text">
            <p>This estimate is based on the information you’ve entered so far for commonly requested coverages, deductibles and limits. If you are happy with this estimate and the details below, click Apply.
                Otherwise, you can adjust the coverages to see an updated premium estimate.
            </p>
          </div>
      );
  }
  return EstQuoteText;
}